(() => {
  const q=(s,r=document)=>r.querySelector(s), qa=(s,r=document)=>[...r.querySelectorAll(s)];
  const root=window.Shopify?.routes?.root || '/';
  const money=(cents,currency='INR')=>{try{return new Intl.NumberFormat('en-IN',{style:'currency',currency}).format((cents||0)/100)}catch(e){return '₹'+((cents||0)/100).toFixed(2)}};
  const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));

  // Mobile navigation drawer
  const mobileDrawer=q('[data-mobile-drawer]');
  const mobileOverlay=q('[data-mobile-overlay]');
  const mobileToggle=q('[data-mobile-toggle]');
  const openMobileMenu=()=>{
    mobileDrawer?.classList.add('is-open');
    mobileOverlay?.classList.add('is-open');
    mobileDrawer?.setAttribute('aria-hidden','false');
    mobileToggle?.setAttribute('aria-expanded','true');
    document.body.classList.add('thinai-menu-open');
  };
  const closeMobileMenu=()=>{
    mobileDrawer?.classList.remove('is-open');
    mobileOverlay?.classList.remove('is-open');
    mobileDrawer?.setAttribute('aria-hidden','true');
    mobileToggle?.setAttribute('aria-expanded','false');
    document.body.classList.remove('thinai-menu-open');
  };
  mobileToggle?.addEventListener('click',()=>mobileDrawer?.classList.contains('is-open')?closeMobileMenu():openMobileMenu());
  qa('[data-mobile-close]').forEach(b=>b.addEventListener('click',closeMobileMenu));
  mobileOverlay?.addEventListener('click',closeMobileMenu);
  qa('.thinai-mobile-categories a,.thinai-mobile-primary a,.thinai-mobile-links a').forEach(a=>a.addEventListener('click',closeMobileMenu));

  // Product gallery
  qa('[data-pdp-thumb]').forEach(b=>b.addEventListener('click',()=>{const img=q('[data-pdp-main]'); if(img) img.src=b.dataset.src;}));

  // Product quantity selector
  qa('[data-qty-minus]').forEach(btn=>btn.addEventListener('click',()=>{
    const input=q('[data-qty-input]',btn.closest('[data-product-form]'));
    if(input) input.value=Math.max(1,(Number(input.value)||1)-1);
  }));
  qa('[data-qty-plus]').forEach(btn=>btn.addEventListener('click',()=>{
    const input=q('[data-qty-input]',btn.closest('[data-product-form]'));
    if(input) input.value=Math.max(1,(Number(input.value)||1)+1);
  }));
  qa('[data-qty-input]').forEach(input=>input.addEventListener('change',()=>{input.value=Math.max(1,Number(input.value)||1)}));

  // Variant price
  q('[data-variant-select]')?.addEventListener('change',e=>{
    const o=e.target.selectedOptions[0], box=q('[data-pdp-price]'); if(!box||!o)return;
    const compare=o.dataset.compare||'';
    box.innerHTML=`<span class="current-price">${esc(o.dataset.price||'')}</span>${compare?`<span class="mrp-price">${esc(compare)}</span><span class="discount-tag">Save Special</span>`:''}`;
  });

  // Cart drawer
  const drawer=q('[data-cart-drawer]'), overlay=q('[data-drawer-overlay]');
  const openDrawer=async()=>{closeMobileMenu();await refreshCart();drawer?.classList.add('is-open');overlay?.classList.add('is-open');document.body.style.overflow='hidden'};
  const closeDrawer=()=>{drawer?.classList.remove('is-open');overlay?.classList.remove('is-open');document.body.style.overflow=''};
  qa('[data-cart-open]').forEach(b=>b.addEventListener('click',openDrawer));
  qa('[data-cart-close]').forEach(b=>b.addEventListener('click',closeDrawer));
  overlay?.addEventListener('click',closeDrawer);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeDrawer();closeMobileMenu();}});

  function flyButterflyToCart(source){
    if(!source) return;
    const cartTriggers=qa('[data-cart-open]').filter(el=>{
      const r=el.getBoundingClientRect();
      const cs=getComputedStyle(el);
      return r.width>0 && r.height>0 && cs.display!=='none' && cs.visibility!=='hidden';
    });
    const target=cartTriggers[cartTriggers.length-1] || cartTriggers[0];
    if(!target) return;

    const s=source.getBoundingClientRect();
    const t=target.getBoundingClientRect();
    const startX=s.left + s.width/2;
    const startY=s.top + s.height/2;
    const endX=t.left + t.width/2;
    const endY=t.top + t.height/2;

    const node=document.createElement('div');
    node.className='thinai-butterfly-fly';
    node.innerHTML='🦋';
    node.style.left=startX+'px';
    node.style.top=startY+'px';
    document.body.appendChild(node);

    const dx=endX-startX;
    const dy=endY-startY;
    requestAnimationFrame(()=>{
      node.style.transform=`translate(${dx}px, ${dy}px) scale(0.55) rotate(18deg)`;
      node.style.opacity='0.12';
    });

    setTimeout(()=>{ try{ node.remove(); }catch(e){} }, 900);
  }

  async function refreshCart(){
    try{
      const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'}}), cart=await r.json();
      qa('[data-cart-count]').forEach(x=>x.textContent=cart.item_count);
      const sub=q('[data-cart-subtotal]'); if(sub)sub.textContent=money(cart.total_price,cart.currency);
      const box=q('[data-cart-items]'); if(!box)return;
      if(!cart.items.length){box.innerHTML='<div class="empty-state">Your bag is currently empty.</div>';return;}
      box.innerHTML=cart.items.map((it,i)=>`<div class="drawer-item">
        <a href="${it.url}">${it.image?`<img src="${it.image}" alt="${esc(it.product_title)}">`:'<div>🌿</div>'}</a>
        <div><a class="drawer-item-title" href="${it.url}">${esc(it.product_title)}</a>${it.variant_title&&it.variant_title!=='Default Title'?`<div class="cart-line-meta">${esc(it.variant_title)}</div>`:''}<div class="cart-line-meta">${money(it.final_price,cart.currency)}</div><div class="drawer-controls"><button data-line="${i+1}" data-qty="${Math.max(0,it.quantity-1)}">−</button><span>${it.quantity}</span><button data-line="${i+1}" data-qty="${it.quantity+1}">+</button><button class="remove" data-line="${i+1}" data-qty="0">Remove</button></div></div>
        <strong>${money(it.final_line_price,cart.currency)}</strong></div>`).join('');
      qa('[data-line][data-qty]',box).forEach(btn=>btn.addEventListener('click',async()=>{btn.disabled=true;await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:Number(btn.dataset.line),quantity:Number(btn.dataset.qty)})});await refreshCart();}));
    }catch(e){console.error(e)}
  }

  // AJAX add-to-cart
  document.addEventListener('submit',async e=>{
    const f=e.target.closest('[data-ajax-add]'); if(!f)return; e.preventDefault();
    const b=f.querySelector('[type=submit]'), old=b?.textContent; if(b){b.disabled=true;b.textContent='ADDING…'}
    try{
      const r=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(f),headers:{Accept:'application/json'}});
      if(!r.ok)throw new Error('Unable to add this item.');
      await refreshCart();
      flyButterflyToCart(b || f);
    }
    catch(err){alert(err.message)} finally{if(b){b.disabled=false;b.textContent=old}}
  });

  // Buy now: add selected product/variant, then continue to Shopify checkout
  qa('[data-buy-now]').forEach(btn=>btn.addEventListener('click',async()=>{
    const form=btn.closest('[data-product-form]'); if(!form)return;
    const old=btn.textContent; btn.disabled=true; btn.textContent='OPENING CHECKOUT…';
    try{
      const r=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      if(!r.ok) throw new Error('Unable to start checkout.');
      window.location.assign(root+'checkout');
    }catch(err){alert(err.message);btn.disabled=false;btn.textContent=old;}
  }));

  // Predictive product search
  const inp=q('[data-predictive-input]'), results=q('[data-predictive-results]'); let t;
  inp?.addEventListener('input',()=>{clearTimeout(t);const term=inp.value.trim();if(term.length<2){results?.classList.remove('is-open');return;}t=setTimeout(()=>search(term),220)});
  document.addEventListener('click',e=>{if(!e.target.closest('.search-wrap'))results?.classList.remove('is-open')});
  async function search(term){try{const r=await fetch(`${root}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6`,{headers:{Accept:'application/json'}}),d=await r.json(),ps=d?.resources?.results?.products||[];if(!results)return;results.innerHTML=ps.length?ps.map(p=>`<a class="predictive-item" href="${p.url}">${p.image?`<img src="${p.image}" alt="">`:''}<div><div class="predictive-item-title">${esc(p.title)}</div><div class="predictive-item-price">${money(p.price)}</div></div></a>`).join(''):'<div class="predictive-item">No products found</div>';results.classList.add('is-open')}catch(e){results?.classList.remove('is-open')}}
  refreshCart();
})();

/* Thinai V1.2: collection sale tab, original blog reader, drawer stacking and bottom nav */
(() => {
  const q=(s,r=document)=>r.querySelector(s), qa=(s,r=document)=>[...r.querySelectorAll(s)];

  // Escape the sticky-header stacking context so the drawer always renders in front.
  const drawer=q('[data-mobile-drawer]');
  const overlay=q('[data-mobile-overlay]');
  const bottomNav=q('[data-mobile-bottom-nav]');
  if(overlay && overlay.parentElement!==document.body) document.body.appendChild(overlay);
  if(drawer && drawer.parentElement!==document.body) document.body.appendChild(drawer);
  if(bottomNav && bottomNav.parentElement!==document.body) document.body.appendChild(bottomNav);

  // Secondary Products button in the fixed bottom nav opens the same category drawer.
  qa('[data-mobile-toggle-secondary]').forEach(btn=>btn.addEventListener('click',()=>{
    drawer?.classList.add('is-open');
    overlay?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden','false');
    document.body.classList.add('thinai-menu-open');
  }));

  // Collection quick filters + current-page sale view.
  qa('[data-collection-page]').forEach(page=>{
    const cards=qa('[data-product-card]',page);
    const count=q('[data-visible-product-count]',page);
    const empty=q('[data-sale-empty]',page);
    const saleButton=q('[data-sale-filter]',page);
    const quickButtons=qa('[data-quick-filter]',page);
    const state={saleOnly:false,filter:'all'};

    const updateCollectionView=()=>{
      let visible=0;
      cards.forEach(card=>{
        const priceCents=Number(card.dataset.price||0);
        const inStock=card.dataset.available==='true';
        const onSale=card.dataset.onSale==='true';
        let show=true;

        if(state.saleOnly && !onSale) show=false;
        if(state.filter==='in-stock' && !inStock) show=false;
        if(state.filter==='under-250' && !(priceCents > 0 && priceCents < 25000)) show=false;
        if(state.filter==='250-500' && !(priceCents >= 25000 && priceCents <= 50000)) show=false;
        if(state.filter==='500-plus' && !(priceCents > 50000)) show=false;

        card.hidden=!show;
        card.dataset.saleHidden=show ? 'false' : 'true';
        if(show) visible++;
      });

      if(count) count.textContent=visible;
      if(empty) empty.hidden=visible>0;
      quickButtons.forEach(btn=>btn.classList.toggle('is-active', btn.dataset.quickFilter===state.filter));
      if(saleButton) saleButton.classList.toggle('is-active', state.saleOnly);
    };

    quickButtons.forEach(btn=>btn.addEventListener('click',()=>{
      state.filter=btn.dataset.quickFilter || 'all';
      if(state.filter==='all') state.saleOnly=false;
      updateCollectionView();
    }));

    saleButton?.addEventListener('click',()=>{
      state.saleOnly=!state.saleOnly;
      if(state.saleOnly){
        qa('.thinai-collection-pill[href]',page).forEach(x=>x.classList.remove('is-active'));
      }
      updateCollectionView();
    });

    updateCollectionView();
  });

  // Restore the exact in-page blog-reader behaviour from the original HTML.
  const modal=q('[data-blog-modal]'), title=q('[data-blog-modal-title]'), meta=q('[data-blog-modal-meta]'), body=q('[data-blog-modal-body]');
  const closeBlog=()=>{modal?.classList.remove('is-open');modal?.setAttribute('aria-hidden','true');document.body.classList.remove('thinai-blog-open')};
  qa('[data-blog-open]').forEach(card=>card.addEventListener('click',()=>{
    const tpl=q(`#thinai-blog-${card.dataset.blogOpen}`); if(!tpl||!modal||!body)return;
    if(title)title.textContent=card.dataset.blogTitle||'Thinai Wellness Blog';
    if(meta)meta.textContent=card.dataset.blogMeta||'Thinai Organics';
    body.innerHTML=tpl.innerHTML;
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); document.body.classList.add('thinai-blog-open');
  }));
  qa('[data-blog-close]').forEach(btn=>btn.addEventListener('click',closeBlog));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&modal?.classList.contains('is-open'))closeBlog()});
})();


/* =========================================================
   THINAI V5.15 — STATIC SIX-CATEGORY NAV
   No cloning / marquee. Header shows the six main categories once.
   ========================================================= */

